<template>
    <div class="m-pop">
        <div class="pop-mask"></div>
        <div class="pop-con bom">
            <div class="title">
                <h3>物料清单（BOM）</h3>
                <div class="close" @click="close">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <div class="info-box">
                <div class="info">
                    <h3>产品信息</h3>
                    <p>
                        产品名称：<strong>{{ bomInfo.productName || '组合灯具' }}</strong>
                    </p>
                    <p>
                        <span>制作日期：{{ bomInfo.createDate || new Date().toLocaleString() }}</span>
                    </p>
                    <p>
                        <span>总配件数：{{ bomInfo.totalParts || 0 }}</span>
                    </p>
                    <p>
                        <span>产品总价：<strong class="price">{{ bomInfo.productSize || '0元' }}</strong></span>
                    </p>
                </div>
                <div class="table">
                    <h3>产品信息</h3>
                    <table>
                        <thead>
                        <tr>
                            <th>序号</th>
                            <th>配件编码</th>
                            <th>配件名称</th>
                            <th>类别</th>
                            <th>规格</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in bomList" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.partCode }}</td>
                            <td>{{ item.partName }}</td>
                            <td>{{ item.category }}</td>
                            <td>{{ item.specification }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="bot-btn">
                <div class="bom-btn" @click="generateBomReport">
                    <div class="icon">
                        <img class="act" src="@/assets/images/bg-t.svg" alt="">
                        <img class="def" src="@/assets/images/bg.svg" alt="">
                    </div>
                    <span>生成BOM表</span>
                </div>
                <el-button type="info" @click="close">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        bomInfo: {
            type: Object,
            default: () => ({})
        },
        bomList: {
            type: Array,
            default: () => []
        },
        combinationId: {
            type: String,
            default: ''
        }
    },
    methods: {
        close: function () {
            this.$emit('close')
        },
        openReg: function () {
            this.$emit('openReg')
        },
        generateBomReport: function () {
            // 触发生成BOM表的事件，传递组合ID
            this.$emit('generateBom', this.combinationId)
        }
    }
}
</script>


<style scoped lang="scss">
.info {
    h3{margin-bottom: 0.2rem;}
    p {
        margin-bottom: 0.2rem;
        line-height: 0.8;
    }
    .price {
        font-weight: bold;
        font-size: 1.2em;
        color: #ff7300;
    }
}
</style>
